<template>
  <div class="home_layout">
    <div class="home_body">
      <div class="data-list" v-if="dataList.length > 0">
        <div v-for="item in dataList" :key="item.orderDetailId" class="coupon-item">
          <div class="coupon-content" @click="detailClick(item)">
            <div class="left">
              <img class="pic" :src="item.picUrl"/>
              <div class="coupon-info">
                <div class="coupon-title">{{ item.goodsName }}</div>
                <div>
                  <div class="coupon-validate">领取日期{{ item.cardStartTime }}</div>
                  <div class="coupon-validate">有效期至{{ item.cardExpirationTime }}</div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="coupon-amount">
                <div class="amount">
                  <span>{{ item.amount }}</span>
                  元
                </div>
              </div>
              <div class="btn" :class="{ 'expired-btn': !item.enabledStatus }" @click.stop="detailClick(item)">
                {{ showEnabledStatus(item.enabledStatus, item.cardUseStatus) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="home_body_middle_nodata">
        <img
            src="../../../static/images/vip_discounts/nodata.png"
            alt=""
            width="100%"
            class="home_body_middle_nodata_img"/>
        <p class="home_body_middle_nodata_title">暂无优惠券</p>
        <p class="home_body_middle_nodata_content">您还没有领取优惠券喔～</p>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {handleRequestError} from '@/static/js/common'

export default {
  data() {
    return {
      dataList: [],
      couponInfo: {}
    }
  },
  mounted() {
    const id = this.$route.params.orderId
    const couponId = this.$route.params.couponId
    const memberId = this.$route.params.memberId
    const goodsId = this.$route.params.goodsId
    this.couponInfo = {
      couponId,
      memberId,
      goodsId
    }
    this.getRecords(id)
  },
  computed: {
    ...mapState(['loginInfo'])
  },
  filters: {},
  methods: {
    /** 获取列表 */
    getRecords(id) {
      if (id !== undefined && id !== null && id !== '') {
        // 如果 id 存在且有效，则存入 localStorage
        console.info('设置订单 id:', id);
        localStorage.setItem('orderId', id);
      } else {
        // 如果 id 不存在或无效，则从 localStorage 中获取
        id = localStorage.getItem('orderId');
      }
      console.log('orderId', id)
      this.get(this.apis.findCardorderDetailList + '?orderId=' + id)
          .then((res) => {
            if (res.data.code === '0') {
              let data = res.data.data
              this.dataList = data
              console.log('777', res.data.data)
            }
          })
          .catch((error) => {
            console.log(error)
            handleRequestError(this, error)
          })
    },
    showEnabledStatus(status, cardStatus) {
      if (!status) {
        return '未生效'
      }
      if (status && cardStatus === '0') {
        return '立即使用'
      } else {
        return '查看'
      }
    },
    showTime(item) {
      if (item.enabledStatus) {
        return item.cardStartTime + ' - ' + item.cardExpirationTime
      } else {
        // return "生效时间：" + item.cardStartTime;
        return '生效时间：第一张使用后7天'
      }
    },
    /** 查看 */
    detailClick(item) {
      console.log(item)
      if (item.enabledStatus) {
        this.$router.push({
          name: 'couponDetail',
          params: {
            goodsName: item.goodsName,
            regionNo: this.$route.params.regionNo,
            orderId: item.orderId,
            orderDetailId: item.orderDetailId,
            couponId: this.couponInfo.couponId,
            memberId: this.couponInfo.memberId,
            seeFlag: item.cardUseStatus != '0' ? '2' : '1',
            goodsId: this.couponInfo.goodsId,
            cardgoodsId: item.id
          }
        })

        if (item.goodsName) {
          console.log('存入goodsName' + item.goodsName)
          localStorage.setItem('goodsName', item.goodsName)
        }

        if (item.orderDetailId) {
          console.log('存入orderDetailId' + item.orderDetailId)
          localStorage.setItem('goodsOrderDetailId', item.orderDetailId)
        }

        if (item.cardgoodsId) {
          console.log('存入cardgoodsId' + item.cardgoodsId)
          localStorage.setItem('CardGoodsId', item.cardgoodsId)
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
.home_layout {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
}

.home_body {
  width: 100%;
  height: 100%;
  padding-top: 26px;

  .coupon-item {
    padding: 0 24px;
    margin-bottom: 16px;

    .coupon-content {
      background: #fff;
      border-radius: 16px;
      display: flex;

      .left {
        display: flex;
        flex: 1;
        padding-right: 28px;
        border-right: 1px dashed #d3d3d3;
        padding: 20px 20px 20px 28px;

        .coupon-info {
          margin-left: 24px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .coupon-title {
            font-size: 26px;
            color: #3f2a20;
            line-height: 38px;
            font-weight: bold;
          }

          .coupon-count {
            font-size: 22px;
            color: #dd5701;
            line-height: 33px;
            margin-top: 10px;
          }

          .coupon-validate {
            font-size: 20px;
            color: #919191;
            line-height: 28px;

            &:first-child {
              margin-bottom: 12px;
            }
          }
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 20px 28px 20px 28px;

        .coupon-amount {
          color: #dd5701;
          font-size: 30px;
          display: flex;
          align-items: center;
          flex: 1;

          .amount {
            display: flex;
            align-items: end;
          }

          span {
            font-size: 60px;
            margin-right: 6px;
            font-weight: bold;
            line-height: 1;
          }
        }

        .btn {
          width: 170px;
          height: 56px;
          line-height: 56px;
          border-radius: 32px;
          background: #fb7019;
          color: #fff;
          font-size: 28px;
          text-align: center;
        }

        .expired-btn {
          background: rgba(251, 112, 25, 0.1);
          color: #dd5701;
        }
      }

      .pic {
        width: 176px;
        height: 176px;
        border-radius: 16px;
        display: block;
      }
    }
  }

  &_middle {
    &_nodata {
      display: grid;
      justify-content: center;
      align-items: center;
      padding-top: 30%;

      &_img {
        max-width: 200px;
        margin: 0 auto;
      }

      &_title {
        color: #3f3f3f;
        font-size: 30px;
        text-align: center;
        margin-top: 24px;
        font-weight: 400;
      }

      &_content {
        color: #848484;
        font-size: 20px;
        text-align: center;
        margin-top: 16px;
      }
    }
  }
}
</style>
